import { TextField } from "@mui/material";
import { GridFilterOperator } from "@mui/x-data-grid-pro";
import createFilter from "./helpers/CreateFilterHelper";

const CustomFilterOperatorInputText = (props: any) => {
  const { item, applyValue } = props;
  const handleChange = (event: any) => {
    applyValue({ ...item, value: event.target.value });
  };
  return <TextField 
    placeholder={props.label} 
    variant="filled" 
    size="small" 
    value={item.value || ''} 
    onChange={handleChange} 
    inputProps={{ "aria-label":"Contains Only Text Filter Input" }}
  />;
};

const ContainsOnlyTextFilterOperator: GridFilterOperator[] = [
  {
      label: 'Contains',
      value: 'contains',
      getApplyFilterFn: createFilter((cellValue, filterValue) => 
          cellValue.toString().toLowerCase().includes(filterValue.toString().toLowerCase())
      ),
      InputComponentProps: { type: 'text' },
      InputComponent: CustomFilterOperatorInputText,
  }
];

export default ContainsOnlyTextFilterOperator;